<template>
  <div class="icon">
    <svg class="icon_svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 70.402 70.402">
      <g id="Group_322" data-name="Group 322" transform="translate(-454.795 -96.788)">
        <circle id="Ellipse_40" data-name="Ellipse 40" cx="35.201" cy="35.201" r="35.201" transform="translate(454.795 96.788)" :class="['svg-fill--' + color]"/>
        <path id="Path_512" data-name="Path 512" d="M2754.849,993.853a20.983,20.983,0,0,0-1.659-8.9c3.612-6.922,3.4-16.941,3.483-19.251a2.94,2.94,0,0,0-.368-1.718.7.7,0,0,0-1.286.248c-.883,4.616-1.2,9.512-3.814,13.608a3.54,3.54,0,0,1-1.853,1.442,7.371,7.371,0,0,1-2.46.235,6.077,6.077,0,0,0,.66-.4,2.509,2.509,0,0,0,.248-.183,4.926,4.926,0,0,0,.586-.477c.147-.137.284-.275.413-.421.073-.083.137-.165.2-.248a6.228,6.228,0,0,0,1.421-3.917,6.393,6.393,0,0,0-6.272-6.35,6.295,6.295,0,0,0-4.132,11.092c.128.11.265.22.4.33.083.055.165.119.247.174a6,6,0,0,0,.661.4c-4.584,1.182-7.957,5.555-7.957,14.337Z" transform="translate(-2267.717 -850.394)" fill="#fff"/>
        <path id="Path_513" data-name="Path 513" d="M2761.263,993.853a20.981,20.981,0,0,1,1.66-8.9c-3.612-6.922-3.332-15.069-3.415-17.379a2.942,2.942,0,0,1,.368-1.718.7.7,0,0,1,1.286.248c.883,4.616,1.128,7.64,3.746,11.736a3.535,3.535,0,0,0,1.853,1.442,7.368,7.368,0,0,0,2.459.235,6.077,6.077,0,0,1-.66-.4,2.616,2.616,0,0,1-.247-.183,4.917,4.917,0,0,1-.587-.477c-.146-.137-.284-.275-.412-.421-.074-.083-.138-.165-.2-.248a6.241,6.241,0,0,1-1.421-3.917,6.4,6.4,0,0,1,6.272-6.35,6.3,6.3,0,0,1,4.133,11.092c-.128.11-.266.22-.4.33-.082.055-.164.119-.247.174a6.1,6.1,0,0,1-.66.4c4.584,1.182,7.957,5.555,7.957,14.337Z" transform="translate(-2267.717 -850.394)" fill="#fff"/>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'orange-icon',
  props: ['color']
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .icon{
    display: flex; -js-display: flex;
    height: 100%;
    align-items: center;
  }

  .icon_svg{
    flex: 0 0 30px;
    height: 30px;
    width: 30px;
  }

  .cls-2{fill: $gray-lightest;}

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/AttributesNavigation/assets/ParticipatoryEngagementIcon.vue